const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/*
 * Fallback for Shopify's Standard Events API.
 *
 * cart.js declares `class CartItems extends window.StandardEvents.createViewEventElement(HTMLElement)`.
 * On this shop the platform does not inject `window.StandardEvents`, so cart.js threw at parse
 * time. That left CartItems undefined, which in turn broke cart-drawer.js and the cart page.
 *
 * The shim only fills the gap when the real API is absent; when Shopify provides it, the native
 * implementation is left untouched. The base class must expose connectedCallback and
 * disconnectedCallback because CartItems calls super on both. View analytics events are no-ops.
 */
window.StandardEvents = window.StandardEvents || {};
if (typeof window.StandardEvents.createViewEventElement !== 'function') {
  window.StandardEvents.createViewEventElement = function (BaseElement) {
    return class extends BaseElement {
      connectedCallback() {}
      disconnectedCallback() {}
      dispatchViewEvent() {}
    };
  };
}
